import adminApiFetch from './apiService'

const purchaseOrderService = {
  getRecords: async (params = {}) => {
    const res = await adminApiFetch('purchase_orders/get_records', { method: 'POST', body: params })
    return res.json()
  },

  getIds: async (params = {}) => {
    const res = await adminApiFetch('purchase_orders/get_ids', { method: 'POST', body: params })
    return res.json()
  },

  export: async (ids) => {
    const res = await adminApiFetch('purchase_orders/export', { method: 'POST', body: { ids } })
    return res.json()
  },

  get: async (id) => {
    const res = await adminApiFetch(`purchase_orders/${id}`, { method: 'GET' })
    return res.json()
  },

  suggestName: async () => {
    const res = await adminApiFetch('purchase_orders/suggest_name', { method: 'GET' })
    return res.json()
  },

  create: async (data) => {
    const res = await adminApiFetch('purchase_orders', { method: 'POST', body: { purchase_order: data } })
    return res.json()
  },

  update: async (id, data) => {
    const res = await adminApiFetch(`purchase_orders/${id}`, { method: 'PUT', body: { purchase_order: data } })
    return res.json()
  },

  submit: async (id) => {
    const res = await adminApiFetch(`purchase_orders/${id}/submit`, { method: 'POST' })
    return res.json()
  },

  approve: async (id) => {
    const res = await adminApiFetch(`purchase_orders/${id}/approve`, { method: 'POST' })
    return res.json()
  },

  reject: async (id) => {
    const res = await adminApiFetch(`purchase_orders/${id}/reject`, { method: 'POST' })
    return res.json()
  },

  cancel: async (id) => {
    const res = await adminApiFetch(`purchase_orders/${id}/cancel`, { method: 'POST' })
    return res.json()
  },

  shortClose: async (id, closeReason) => {
    const res = await adminApiFetch(`purchase_orders/${id}/short_close`, { method: 'POST', body: { close_reason: closeReason } })
    return res.json()
  },

  close: async (id) => {
    const res = await adminApiFetch(`purchase_orders/${id}/close`, { method: 'POST' })
    return res.json()
  },

  createInbound: async (id, data) => {
    const res = await adminApiFetch(`purchase_orders/${id}/create_inbound`, { method: 'POST', body: data })
    return res.json()
  },

  getHistories: async (id) => {
    const res = await adminApiFetch(`purchase_orders/${id}/purchase_order_histories`, { method: 'GET' })
    return res.json()
  },

  // --- Attachments ---

  createAttachment: async (poId, file) => {
    const formData = new FormData()
    formData.append('file', file)
    const res = await adminApiFetch(`purchase_orders/${poId}/purchase_order_attachments`, { method: 'POST', body: formData })
    return res.json()
  },

  deleteAttachment: async (poId, attachmentId) => {
    const res = await adminApiFetch(`purchase_orders/${poId}/purchase_order_attachments/${attachmentId}`, { method: 'DELETE' })
    return res.json()
  },

  // --- Comments / Timeline ---

  getTimeline: async (poId) => {
    const res = await adminApiFetch(`purchase_orders/${poId}/purchase_order_comments`, { method: 'GET' })
    return res.json()
  },

  createComment: async (poId, body) => {
    const res = await adminApiFetch(`purchase_orders/${poId}/purchase_order_comments`, { method: 'POST', body: { body } })
    return res.json()
  },

  updateComment: async (poId, commentId, body) => {
    const res = await adminApiFetch(`purchase_orders/${poId}/purchase_order_comments/${commentId}`, { method: 'PUT', body: { body } })
    return res.json()
  },

  deleteComment: async (poId, commentId) => {
    const res = await adminApiFetch(`purchase_orders/${poId}/purchase_order_comments/${commentId}`, { method: 'DELETE' })
    return res.json()
  },

  // --- Invoices ---

  getInvoices: async (poId) => {
    const res = await adminApiFetch(`purchase_orders/${poId}/purchase_order_invoices`, { method: 'GET' })
    return res.json()
  },

  createInvoice: async (poId, data) => {
    const res = await adminApiFetch(`purchase_orders/${poId}/purchase_order_invoices`, { method: 'POST', body: data })
    return res.json()
  },

  updateInvoice: async (poId, invoiceId, data) => {
    const res = await adminApiFetch(`purchase_orders/${poId}/purchase_order_invoices/${invoiceId}`, { method: 'PUT', body: data })
    return res.json()
  },

  cancelInvoice: async (poId, invoiceId) => {
    const res = await adminApiFetch(`purchase_orders/${poId}/purchase_order_invoices/${invoiceId}/cancel`, { method: 'POST' })
    return res.json()
  },

  // --- Payments ---

  createPayment: async (poId, invoiceId, data) => {
    const res = await adminApiFetch(`purchase_orders/${poId}/purchase_order_invoices/${invoiceId}/invoice_payments`, { method: 'POST', body: data })
    return res.json()
  },

  deletePayment: async (poId, invoiceId, paymentId) => {
    const res = await adminApiFetch(`purchase_orders/${poId}/purchase_order_invoices/${invoiceId}/invoice_payments/${paymentId}`, { method: 'DELETE' })
    return res.json()
  },
}

export { purchaseOrderService }
export default purchaseOrderService
